/**
 * projectName 租户间稿库路由
 * createTime 2019-05-20
 * name zhang.yingyu
 */
"use strict";
angular.module("tenantManuscriptRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state('front.resourcectrl.tenantmanuscript.receive', { //租户间稿库收到
        url: "/receive?id",
        views: {
            'main@front.resourcectrl.tenantmanuscript': {
                templateUrl: './resourceCenter/tenantManuscript/receiveTenant/main_tpl.html',
                controller: 'receiveTenantCtrl',
            }
        },
    }).state('front.resourcectrl.tenantmanuscript.post', { //租户间稿库发出
        url: "/post?id",
        views: {
            'main@front.resourcectrl.tenantmanuscript': {
                templateUrl: './resourceCenter/tenantManuscript/postTenant/main_tpl.html',
                controller: 'postTenantCtrl',
            }
        },
    }).state("tenantmanuscriptdetail", { //租户间共享稿库细览详情
        url: "/tenantmanuscriptdetail?dataid&source",
        //url:"/resourcegxgkdetail?iwometadataid&iwochnldocid&iwotype&iwomodalname&appchannelid&appchnldocid&appsiteid&appmetadataid&appplatform&appdoctype&wzchannelid&wzchnldocid&wzsiteid&wzmetadataid&wzplatform&wztypeid&bzmetadata&bzchnlid&paperid&newspapertype&nodeid&frompictures",
        views: {
            '': {
                templateUrl: './resourceCenter/tenantManuscript/tenantManuscriptPreview/tenantManuscriptPreview_tpl.html',
                controller: 'tenantManuscriptPreviewCtrl'
            }
        }
    });
}]);